// // Version 3: is supposed to show broken reservations, but doesn't work. Worth trying to debug in the future.
// // first step to debug would be to feed it July's availability grid and explain that the outcome shouldn't be 
// // for July 24 to have reservations that say they aren't broken, when really July 24 has no availability at all
// // for regular serviced sites.
// import { useEffect, useState } from "react";

// export default function Availability() {
//   const [selectedSiteType, setSelectedSiteType] = useState("2-person");
//   const [campingUnit, setCampingUnit] = useState("tent");
//   const [unitLength, setUnitLength] = useState("");

//   const [arrivalDate, setArrivalDate] = useState("");
//   const [departureDate, setDepartureDate] = useState("");

//   const [stayPlanMessage, setStayPlanMessage] = useState("");

//   const [months, setMonths] = useState([]);
//   const [siteData, setSiteData] = useState([]);

//   const monthNames = ["May", "June", "July", "August", "September", "October"];

//   const premiumSiteLengths = {
//     "2": 35, "3": 34, "4": 32, "30": 26, "30A": 36,
//     "32": 32, "33": 35, "36": 32, "37": 38, "38": 30,
//     "39": 30, "40": 35, "43": 40, "53": 40, "55": 28,
//     "56": 30, "65": 28, "66": 34, "68": 26, "B": 28,
//     "C": 28, "D": 28, "E": 26, "F": 24, "G": 32,
//     "S1": 32, "S2": 38, "Z": 40, "01": 42, "104": 25,
//     "110": 35,
//   };

//   const regularSiteLengths = {
//     "4A": 22, "5": 22, "6": 19, "7": 19, "31": 22,
//     "41": 20, "50": 20, "54": 20, "67": 24, "69": 26,
//     "70": 22, "71": 25, "72": 26, "73": 22, "76": 22,
//     "A": 18, "H": 20, "L": 0, "M": 22, "Q": 20,
//     "Y": 24, "U": 12, "V": 12,
//   };

//   const getCabinType = (site) => {
//     if (["011", "012", "WF1"].includes(site)) return "2-person";
//     return "4-person";
//   };

//   const formatDay = (raw) => {
//     const match = raw.match(/^([A-Za-z]+)(\d+)$/);
//     if (!match) return { dayName: raw, dayNum: "" };

//     const map = {
//       Mo: "Mon",
//       Tu: "Tue",
//       We: "Wed",
//       Th: "Thu",
//       Fr: "Fri",
//       Sa: "Sat",
//       Su: "Sun",
//     };

//     return {
//       dayName: map[match[1]] || match[1],
//       dayNum: match[2],
//     };
//   };

//   const parseSingleHtml = (doc) => {
//     const tables = doc.querySelectorAll("table");

//     const table = Array.from(tables).find((t) =>
//       t.innerText.includes("Site")
//     );

//     if (!table) return null;

//     const rows = Array.from(table.querySelectorAll("tr"));
//     if (rows.length < 3) return null;

//     const headerCells = Array.from(rows[1].querySelectorAll("td"));

//     const extractedDays = headerCells
//       .slice(1, -1)
//       .map((td) => td.innerText.replace(/\s+/g, "").trim());

//     const data = [];

//     for (let i = 2; i < rows.length - 1; i++) {
//       const cells = Array.from(rows[i].querySelectorAll("td"));
//       if (cells.length < 5) continue;

//       const site = cells[0].innerText.trim();
//       if (!site || site === "Site") continue;

//       const cabinType = getCabinType(site);

//       const dayValues = cells
//         .slice(1, -1)
//         .map((td) => td.innerText.trim());

//       data.push({
//         site,
//         cabinType,
//         days: dayValues,
//       });
//     }

//     return { extractedDays, data };
//   };

//   const parseAllMonths = async () => {
//     try {
//       const parser = new DOMParser();

//       const monthFiles = [
//         "vacancy00all.html",
//         "vacancy01all.html",
//         "vacancy02all.html",
//         "vacancy03all.html",
//         "vacancy04all.html",
//         "vacancy05all.html",
//       ];

//       const siteMap = {};
//       const monthData = [];

//       for (let i = 0; i < monthFiles.length; i++) {
//         const res = await fetch(`/${monthFiles[i]}`);
//         const htmlText = await res.text();

//         const doc = parser.parseFromString(htmlText, "text/html");
//         const result = parseSingleHtml(doc);

//         if (!result) continue;

//         const { extractedDays, data } = result;

//         monthData.push({
//           name: monthNames[i],
//           days: extractedDays,
//         });

//         data.forEach((siteEntry) => {
//           if (!siteMap[siteEntry.site]) {
//             siteMap[siteEntry.site] = {
//               site: siteEntry.site,
//               cabinType: siteEntry.cabinType,
//               daysByMonth: [],
//             };
//           }

//           siteMap[siteEntry.site].daysByMonth[i] = siteEntry.days;
//         });
//       }

//       setMonths(monthData);
//       setSiteData(Object.values(siteMap));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     parseAllMonths();
//   }, []);

//   const isCabin =
//     selectedSiteType === "2-person" ||
//     selectedSiteType === "4-person";

//   const showLengthInput =
//     !isCabin && campingUnit !== "tent";

//   const filteredSites = siteData.filter((s) => {
//     if (isCabin) return s.cabinType === selectedSiteType;

//     if (selectedSiteType === "premium") {
//       return Object.keys(premiumSiteLengths).includes(s.site);
//     }

//     if (selectedSiteType === "regular") {
//       return Object.keys(regularSiteLengths).includes(s.site);
//     }

//     if (selectedSiteType === "unserviced") {
//       return s.site === "T";
//     }

//     return false;
//   });

//   const getEffectiveLength = () =>
//     campingUnit === "motorhome"
//       ? Math.max(0, Number(unitLength) - 3)
//       : Number(unitLength);

//   const getAvailabilityForMonth = (monthIndex, daysLength) => {
//     return Array.from({ length: daysLength }).map((_, d) => {
//       return filteredSites.some((s) => {
//         const available =
//           s.daysByMonth?.[monthIndex]?.[d] === "V";

//         if (!available) return false;

//         const len = getEffectiveLength();

//         if (selectedSiteType === "premium") {
//           const max = premiumSiteLengths[s.site];
//           return max ? len <= max : true;
//         }

//         if (selectedSiteType === "regular") {
//           if (s.site === "L")
//             return campingUnit === "tent";

//           const max = regularSiteLengths[s.site];
//           return max ? len <= max : true;
//         }

//         return true;
//       })
//         ? "V"
//         : "R";
//     });
//   };

//   // -----------------------------
//   // STAY PLANNER (FIXED LOGIC)
//   // -----------------------------
//   useEffect(() => {
//     if (!arrivalDate || !departureDate) {
//       setStayPlanMessage("");
//       return;
//     }

//     const start = new Date(arrivalDate);
//     const end = new Date(departureDate);

//     if (end <= start) {
//       setStayPlanMessage("Invalid date range");
//       return;
//     }

//     const totalDays = Math.ceil(
//       (end - start) / (1000 * 60 * 60 * 24)
//     );

//     const len = getEffectiveLength();

//     // -----------------------------
//     // STEP 1: CHECK IF ANY DAY IS COMPLETELY UNAVAILABLE
//     // -----------------------------
//     const dayHasAnyAvailability = Array.from({ length: totalDays }).map(
//       (_, globalIndex) => {
//         return filteredSites.some((site) => {
//           let idx = 0;

//           for (let m = 0; m < months.length; m++) {
//             for (let d = 0; d < months[m].days.length; d++) {
//               if (idx === globalIndex) {
//                 const available =
//                   site.daysByMonth?.[m]?.[d] === "V";

//                 if (!available) return false;

//                 if (selectedSiteType === "premium") {
//                   const max = premiumSiteLengths[site.site];
//                   return max ? len <= max : true;
//                 }

//                 if (selectedSiteType === "regular") {
//                   if (site.site === "L")
//                     return campingUnit === "tent";

//                   const max = regularSiteLengths[site.site];
//                   return max ? len <= max : true;
//                 }

//                 return true;
//               }
//               idx++;
//             }
//           }

//           return false;
//         });
//       }
//     );

//     const impossible = dayHasAnyAvailability.includes(false);

//     if (impossible) {
//       setStayPlanMessage(
//         "❌ No availability for the selected date range"
//       );
//       return;
//     }

//     // -----------------------------
//     // STEP 2: SINGLE SITE CHECK
//     // -----------------------------
//     const hasSingleSite = filteredSites.some((site) => {
//       let idx = 0;

//       for (let m = 0; m < months.length; m++) {
//         for (let d = 0; d < months[m].days.length; d++) {
//           if (idx >= totalDays) return true;

//           const available =
//             site.daysByMonth?.[m]?.[d] === "V";

//           if (!available) return false;

//           if (selectedSiteType === "premium") {
//             const max = premiumSiteLengths[site.site];
//             if (max && len > max) return false;
//           }

//           if (selectedSiteType === "regular") {
//             if (site.site === "L")
//               return campingUnit === "tent";

//             const max = regularSiteLengths[site.site];
//             if (max && len > max) return false;
//           }

//           idx++;
//         }
//       }

//       return true;
//     });

//     if (hasSingleSite) {
//       setStayPlanMessage(
//         "✔ Your stay can be completed on a single site"
//       );
//       return;
//     }

//     // -----------------------------
//     // STEP 3: SPLIT (SIMPLIFIED)
//     // -----------------------------
//     let segments = [];
//     let startIdx = 0;

//     for (let i = 0; i <= dayHasAnyAvailability.length; i++) {
//       if (i === dayHasAnyAvailability.length || !dayHasAnyAvailability[i]) {
//         if (i > startIdx) segments.push(i - startIdx);
//         startIdx = i + 1;
//       }
//     }

//     setStayPlanMessage(
//       `⚠ You may need to move during your stay. Segments: ${segments.join(
//         " + "
//       )} nights`
//     );
//   }, [
//     arrivalDate,
//     departureDate,
//     filteredSites,
//     months,
//     unitLength,
//     campingUnit,
//     selectedSiteType,
//   ]);

//   return (
//     <div className="page">
//       <h2>Availability</h2>

//       {stayPlanMessage && (
//         <div style={{ marginBottom: 10, fontWeight: "bold" }}>
//           {stayPlanMessage}
//         </div>
//       )}

//       <input
//         type="date"
//         value={arrivalDate}
//         onChange={(e) => setArrivalDate(e.target.value)}
//       />
//       <input
//         type="date"
//         value={departureDate}
//         onChange={(e) => setDepartureDate(e.target.value)}
//         style={{ marginLeft: 10 }}
//       />

//       <br /><br />

//       <select
//         value={selectedSiteType}
//         onChange={(e) => setSelectedSiteType(e.target.value)}
//       >
//         <option value="unserviced">Unserviced</option>
//         <option value="regular">Regular Serviced</option>
//         <option value="premium">Premium Serviced</option>
//         <option value="50amp">50 Amp</option>
//         <option value="2-person">2-Person Cabin</option>
//         <option value="4-person">4-Person Cabin</option>
//       </select>

//       {!isCabin && (
//         <>
//           <select
//             value={campingUnit}
//             onChange={(e) => setCampingUnit(e.target.value)}
//             style={{ marginLeft: 10 }}
//           >
//             <option value="tent">Tent</option>
//             <option value="popup">Pop-up Trailer</option>
//             <option value="trailer">Trailer</option>
//             <option value="motorhome">Motorhome</option>
//             <option value="truck">Truck Camper</option>
//           </select>

//           {showLengthInput && (
//             <input
//               type="number"
//               placeholder="Length (ft)"
//               value={unitLength}
//               onChange={(e) => setUnitLength(e.target.value)}
//               style={{ marginLeft: 10, width: 100 }}
//             />
//           )}
//         </>
//       )}

//       {months.map((month, mIndex) => {
//         const availability = getAvailabilityForMonth(
//           mIndex,
//           month.days.length
//         );

//         return (
//           <div key={mIndex} style={{ marginTop: 30 }}>
//             <h3>{month.name}</h3>

//             <table border="1" cellPadding="5">
//               <thead>
//                 <tr>
//                   <th>Type</th>
//                   {month.days.map((day, i) => {
//                     const { dayName, dayNum } = formatDay(day);

//                     return (
//                       <th key={i}>
//                         <div style={{ lineHeight: 1.1 }}>
//                           <div style={{ fontSize: 12 }}>
//                             {dayName}
//                           </div>
//                           <div>{dayNum}</div>
//                         </div>
//                       </th>
//                     );
//                   })}
//                 </tr>
//               </thead>

//               <tbody>
//                 <tr>
//                   <td>{selectedSiteType}</td>
//                   {availability.map((v, i) => (
//                     <td
//                       key={i}
//                       style={{
//                         textAlign: "center",
//                         background: v === "V" ? "#90ee90" : "#ffcccb",
//                       }}
//                     >
//                       {v === "V" ? "✔" : "✖"}
//                     </td>
//                   ))}
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// Version 2: was working, doesn't have functionality to see broken reservations
import { useEffect, useState } from "react";

export default function Availability() {
  const [selectedSiteType, setSelectedSiteType] = useState("2-person");
  const [campingUnit, setCampingUnit] = useState("tent");
  const [unitLength, setUnitLength] = useState("");
  const [months, setMonths] = useState([]);
  const [siteData, setSiteData] = useState([]);

  const getCabinType = (site) => {
    if (["011", "012", "WF1"].includes(site)) return "2-person";
    return "4-person";
  };

  const monthNames = ["May", "June", "July", "August", "September", "October"];

  // ✅ Premium site length map
  const premiumSiteLengths = {
    2: 35,
    3: 34,
    4: 32,
    30: 26,
    "30A": 36,
    32: 32,
    33: 35,
    36: 32,
    37: 38,
    38: 30,
    39: 30,
    40: 35,
    43: 40,
    53: 40,
    55: 28,
    56: 30,
    65: 28,
    66: 34,
    68: 26,
    B: 28,
    C: 28,
    D: 28,
    E: 26,
    F: 24,
    G: 32,
    S1: 32,
    S2: 38,
    Z: 40,
    "01": 42,
    104: 25,
    110: 35,
  };

  const regularSiteLengths = {
    "4A": 22,
    5: 22,
    6: 19,
    7: 19,
    31: 22,
    41: 20,
    50: 20,
    54: 20,
    67: 24,
    69: 26,
    70: 22,
    71: 25,
    72: 26,
    73: 22,
    76: 22,
    A: 18,
    H: 20,
    L: 0, // tent-only
    M: 22,
    Q: 20,
    Y: 24,
    U: 12, // update later for pop-ups etc.
    V: 12, // update later etc.
  };

  const formatDay = (raw) => {
    const match = raw.match(/^([A-Za-z]+)(\d+)$/);
    if (!match) return { dayName: raw, dayNum: "" };

    const map = {
      Mo: "Mon",
      Tu: "Tue",
      We: "Wed",
      Th: "Thu",
      Fr: "Fri",
      Sa: "Sat",
      Su: "Sun",
    };

    return {
      dayName: map[match[1]] || match[1],
      dayNum: match[2],
    };
  };

  const parseSingleHtml = (doc) => {
    const tables = doc.querySelectorAll("table");

    const table = Array.from(tables).find((t) => t.innerText.includes("Site"));

    if (!table) return null;

    const rows = Array.from(table.querySelectorAll("tr"));
    if (rows.length < 3) return null;

    const headerCells = Array.from(rows[1].querySelectorAll("td"));

    const extractedDays = headerCells
      .slice(1, -1)
      .map((td) => td.innerText.replace(/\s+/g, "").trim());

    const data = [];

    for (let i = 2; i < rows.length - 1; i++) {
      const cells = Array.from(rows[i].querySelectorAll("td"));
      if (cells.length < 5) continue;

      const site = cells[0].innerText.trim();
      if (!site || site === "Site") continue;

      const cabinType = getCabinType(site);

      const dayValues = cells.slice(1, -1).map((td) => td.innerText.trim());

      data.push({
        site,
        cabinType,
        days: dayValues,
      });
    }

    return { extractedDays, data };
  };

  const parseAllMonths = async () => {
    try {
      const parser = new DOMParser();

      const monthFiles = [
        "vacancy00all.html",
        "vacancy01all.html",
        "vacancy02all.html",
        "vacancy03all.html",
        "vacancy04all.html",
        "vacancy05all.html",
      ];

      const siteMap = {};
      const monthData = [];

      for (let i = 0; i < monthFiles.length; i++) {
        const res = await fetch(`/${monthFiles[i]}`);
        const htmlText = await res.text();

        const doc = parser.parseFromString(htmlText, "text/html");
        const result = parseSingleHtml(doc);

        if (!result) continue;

        const { extractedDays, data } = result;

        monthData.push({
          name: monthNames[i],
          days: extractedDays,
        });

        data.forEach((siteEntry) => {
          if (!siteMap[siteEntry.site]) {
            siteMap[siteEntry.site] = {
              site: siteEntry.site,
              cabinType: siteEntry.cabinType,
              daysByMonth: [],
            };
          }

          siteMap[siteEntry.site].daysByMonth[i] = siteEntry.days;
        });
      }

      setMonths(monthData);
      setSiteData(Object.values(siteMap));
    } catch (err) {
      console.error("Parse failed:", err);
    }
  };

  useEffect(() => {
    parseAllMonths();
  }, []);

  const isCabin =
    selectedSiteType === "2-person" || selectedSiteType === "4-person";

  const showLengthInput = !isCabin && campingUnit !== "tent";

  const filteredSites = siteData.filter((s) => {
    if (isCabin) {
      return s.cabinType === selectedSiteType;
    }

    if (selectedSiteType === "unserviced") {
      return s.site === "T";
    }

    if (selectedSiteType === "regular") {
      return Object.keys(regularSiteLengths).includes(s.site);
    }

    if (selectedSiteType === "premium") {
      return Object.keys(premiumSiteLengths).includes(s.site);
    }

    return false;
  });

  const getAvailabilityForMonth = (monthIndex, daysLength) => {
  return Array.from({ length: daysLength }).map((_, d) => {
    return filteredSites.some((s) => {
      const isAvailable =
        s.daysByMonth?.[monthIndex]?.[d] === "V";

      if (!isAvailable) return false;

      // -----------------------------
      // BASE LENGTH (motorhome rule)
      // -----------------------------
      const effectiveLength =
        campingUnit === "motorhome"
          ? Math.max(0, Number(unitLength) - 3)
          : Number(unitLength);

      // -----------------------------
      // PREMIUM RULES
      // -----------------------------
      if (selectedSiteType === "premium") {
        const maxLength = premiumSiteLengths[s.site];

        if (maxLength === undefined) return true;

        return effectiveLength <= maxLength;
      }

      // -----------------------------
      // REGULAR RULES
      // -----------------------------
      if (selectedSiteType === "regular") {
        const maxLength = regularSiteLengths[s.site];

        // Tent-only site L
        if (s.site === "L") {
          return campingUnit === "tent";
        }

        if (maxLength === undefined) return true;

        return effectiveLength <= maxLength;
      }

      // -----------------------------
      // OTHER SITE TYPES
      // -----------------------------
      return true;
    })
      ? "V"
      : "R";
  });
};

  return (
    <div className="page">
      <h2>Availability</h2>

      <select
        value={selectedSiteType}
        onChange={(e) => setSelectedSiteType(e.target.value)}
      >
        <option value="unserviced">Unserviced</option>
        <option value="regular">Regular Serviced</option>
        <option value="premium">Premium Serviced</option>
        <option value="50amp">50 Amp</option>
        <option value="2-person">2-Person Cabin</option>
        <option value="4-person">4-Person Cabin</option>
      </select>

      {!isCabin && (
        <>
          <select
            value={campingUnit}
            onChange={(e) => setCampingUnit(e.target.value)}
            style={{ marginLeft: "10px" }}
          >
            <option value="tent">Tent</option>
            <option value="popup">Pop-up Trailer</option>
            <option value="trailer">Trailer</option>
            <option value="motorhome">Motorhome</option>
            <option value="truck">Van / Truck Camper</option>
          </select>

          {/* ✅ Length input */}
          {showLengthInput && (
            <input
              type="number"
              placeholder="Length (ft)"
              value={unitLength}
              onChange={(e) => setUnitLength(e.target.value)}
              style={{ marginLeft: "10px", width: "100px" }}
            />
          )}
        </>
      )}

      {months.map((month, mIndex) => {
        const availability = getAvailabilityForMonth(mIndex, month.days.length);

        return (
          <div key={mIndex} style={{ marginTop: "30px" }}>
            <h3>{month.name}</h3>

            <table border="1" cellPadding="5">
              <thead>
                <tr>
                  <th>Type</th>
                  {month.days.map((day, i) => {
                    const { dayName, dayNum } = formatDay(day);

                    return (
                      <th key={i}>
                        <div style={{ lineHeight: "1.1" }}>
                          <div style={{ fontSize: "12px" }}>{dayName}</div>
                          <div style={{ fontWeight: "bold" }}>{dayNum}</div>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{selectedSiteType}</td>
                  {availability.map((val, i) => (
                    <td
                      key={i}
                      style={{
                        backgroundColor: val === "V" ? "#90ee90" : "#ffcccb",
                        textAlign: "center",
                        fontSize: "18px",
                      }}
                    >
                      {val === "V" ? "✔" : "✖"}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}



// V1: was working but only shows cabins
// import { useEffect, useState } from "react";

// export default function Availability() {
//   const [selectedType, setSelectedType] = useState("2-person");
//   const [days, setDays] = useState([]);
//   const [siteData, setSiteData] = useState([]);

//   const getCabinType = (site) => {
//     if (["011", "012", "WF1"].includes(site)) return "2-person";
//     return "4-person";
//   };

//   const parseHtml = async () => {
//     try {
//       const res = await fetch("/vacancy00all.html");
//       const htmlText = await res.text();

//       const parser = new DOMParser();
//       const doc = parser.parseFromString(htmlText, "text/html");

//       const tables = doc.querySelectorAll("table");

//       // ✅ Find the correct table by content
//       const table = Array.from(tables).find((t) =>
//         t.innerText.includes("Site")
//       );

//       if (!table) {
//         console.error("No valid table found");
//         return;
//       }

//       const rows = Array.from(table.querySelectorAll("tr"));

//       if (rows.length < 3) {
//         console.error("Table structure invalid");
//         return;
//       }

//       // ✅ Header row is index 1
//       const headerCells = Array.from(rows[1].querySelectorAll("td"));

//       const extractedDays = headerCells
//         .slice(1, -1)
//         .map((td) => td.innerText.replace(/\s+/g, " ").trim());

//       setDays(extractedDays);

//       // ✅ Parse data rows
//       const data = [];

//       for (let i = 2; i < rows.length - 1; i++) {
//         const cells = Array.from(rows[i].querySelectorAll("td"));

//         if (cells.length < 5) continue;

//         const site = cells[0].innerText.trim();

//         if (!site || site === "Site") continue;

//         const type = getCabinType(site);

//         const dayValues = cells
//           .slice(1, -1)
//           .map((td) => td.innerText.trim());

//         data.push({
//           site,
//           type,
//           days: dayValues,
//         });
//       }

//       setSiteData(data);
//     } catch (err) {
//       console.error("Parse failed:", err);
//     }
//   };

//   useEffect(() => {
//     parseHtml();
//   }, []);

//   const availability =
//     days.length === 0
//       ? []
//       : days.map((_, d) => {
//           return siteData
//             .filter((s) => s.type === selectedType)
//             .some((s) => s.days[d] === "V")
//             ? "V"
//             : "R";
//         });

//   return (
//     <div className="page">
//       <h2>Cabin Availability</h2>

//       <select
//         value={selectedType}
//         onChange={(e) => setSelectedType(e.target.value)}
//       >
//         <option value="2-person">2-Person Cabin</option>
//         <option value="4-person">4-Person Cabin</option>
//       </select>

//       <table border="1" cellPadding="5" style={{ marginTop: "20px" }}>
//         <thead>
//           <tr>
//             <th>Type</th>
//             {days.map((day, i) => (
//               <th key={i}>{day}</th>
//             ))}
//           </tr>
//         </thead>

//         <tbody>
//           <tr>
//             <td>{selectedType}</td>
//             {availability.map((val, i) => (
//               <td
//                 key={i}
//                 style={{
//                   backgroundColor: val === "V" ? "#90ee90" : "#ffcccb",
//                   textAlign: "center",
//                 }}
//               >
//                 {val === "V" ? "Available" : "Full"}
//               </td>
//             ))}
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// }
